import { motion } from "framer-motion";

const TrustBar = () => {
  const pillars = [
    "Property Development",
    "Specialist Conveyancing",
    "Notarial Property and Mining Instruments",
    "Commercial and Governance Advisory",
  ];

  return (
    <section className="bg-charcoal py-8 border-y border-brand-gold/20" data-testid="trust-bar-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {pillars.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-1.5 h-1.5 bg-brand-gold mx-auto mb-3" />
              <span className="text-white/90 font-sans text-xs sm:text-sm font-medium uppercase tracking-wider leading-tight">
                {item}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
